// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================================
   App shell — mobile first.
   Phone/tablet (<992px): navy top bar + drawer nav (+ bottom bar).
   Desktop: navy full-height sider + navy top bar with the page
   title. Content is the scroll container in both (TaskBoard relies
   on .ant-layout-content).
   ============================================================ */

.app-shell {
  height: 100vh;
  height: 100dvh;
  overflow: hidden;
  background: var(--ds-bg);
}

.app-shell__main {
  flex: 1 1 auto;
  min-width: 0;
  min-height: 0;
  overflow: hidden;
  background: var(--ds-bg);
}

/* ── Top bar ── */
.app-topbar.ant-layout-header {
  position: relative;
  z-index: 100;
  display: flex;
  align-items: center;
  gap: var(--ds-space-2);
  height: calc(var(--ds-topbar-h) + var(--ds-safe-top));
  line-height: normal;
  padding: var(--ds-safe-top) calc(var(--ds-space-2) + var(--ds-safe-right)) 0
    calc(var(--ds-space-2) + var(--ds-safe-left));
  background: var(--ds-chrome-bg);
  box-shadow: 0 1px 0 var(--ds-chrome-border), 0 4px 16px rgba(18, 58, 79, 0.18);
  color: var(--ds-chrome-text);
}

.app-topbar__heading {
  flex: 1 1 auto;
  min-width: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 2px;
}

.app-topbar__title {
  margin: 0;
  color: var(--ds-chrome-text-strong);
  font-family: var(--ds-font-display);
  font-size: 1.1rem;
  font-weight: 700;
  letter-spacing: -0.01em;
  line-height: 1.2;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.app-topbar .ant-breadcrumb {
  font-size: 0.78rem;
  line-height: 1.2;
}

.app-topbar .ant-breadcrumb,
.app-topbar .ant-breadcrumb a,
.app-topbar .ant-breadcrumb li:last-child,
.app-topbar .ant-breadcrumb .ant-breadcrumb-separator {
  color: var(--ds-chrome-text-muted);
}

.app-topbar .ant-breadcrumb a:hover {
  color: var(--ds-chrome-text-strong);
  background: transparent;
}

.app-topbar__actions {
  display: flex;
  align-items: center;
  gap: var(--ds-space-1);
  margin-inline-start: auto;
}

.app-topbar__icon-btn.ant-btn {
  width: var(--ds-touch);
  height: var(--ds-touch);
  color: var(--ds-chrome-text-strong) !important;
  font-size: 20px;
  flex-shrink: 0;
  border-radius: var(--ds-radius-md);
}

.app-topbar__icon-btn.ant-btn:hover {
  background: var(--ds-chrome-hover) !important;
}

.app-avatar.ant-avatar {
  flex-shrink: 0;
  background: linear-gradient(135deg, var(--ds-logo-sky), var(--ds-brand));
  color: #fff;
  font-weight: 700;
  font-size: 0.8rem;
  letter-spacing: 0.02em;
}

.app-topbar__user {
  display: flex;
  align-items: center;
  gap: var(--ds-space-2);
  min-width: var(--ds-touch);
  height: var(--ds-touch);
  padding: 0 var(--ds-space-1);
  border: 0;
  border-radius: var(--ds-radius-pill);
  background: transparent;
  color: var(--ds-chrome-text);
  cursor: pointer;
  text-align: start;
}

.app-topbar__user:hover {
  background: var(--ds-chrome-hover);
}

.app-topbar__user .app-avatar.ant-avatar {
  box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.85);
}

.app-topbar__user-text {
  display: flex;
  flex-direction: column;
  line-height: 1.2;
  max-width: 180px;
}

.app-topbar__user-name {
  font-weight: 600;
  font-size: 0.875rem;
  color: var(--ds-chrome-text-strong);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.app-topbar__user-role {
  font-size: 0.75rem;
  color: var(--ds-chrome-text-muted);
  white-space: nowrap;
}

.app-topbar__user-caret {
  font-size: 10px;
  color: var(--ds-chrome-text-muted);
  margin-inline-end: var(--ds-space-1);
}

.app-topbar .language-selector {
  min-width: var(--ds-touch);
  height: var(--ds-touch);
  justify-content: center;
  border-radius: var(--ds-radius-md);
  font-weight: 600;
  color: var(--ds-chrome-text) !important;
}

.app-topbar .language-selector .ant-typography,
.app-topbar .language-selector svg {
  color: inherit !important;
}

.app-topbar .language-selector:hover {
  background: var(--ds-chrome-hover) !important;
  color: var(--ds-chrome-text-strong) !important;
}

.language-country-flag {
  width: 20px;
  border-radius: 3px;
}

/* Profile menu */
.app-usermenu__head {
  display: flex;
  flex-direction: column;
  padding: var(--ds-space-1) 0;
  min-width: 200px;
}

.app-usermenu__name {
  font-weight: 700;
  color: var(--ds-heading);
}

.app-usermenu__role {
  font-size: 0.8rem;
  color: var(--ds-text-2);
  font-weight: 400;
}

/* ── Content ── */
.app-content.ant-layout-content {
  min-width: 0;
  /* normalUsers/assets/css/custom.css centers a template ".app-content" on phones */
  text-align: start;
  overflow-x: hidden;
  overflow-y: auto;
  overscroll-behavior-y: contain;
  padding: var(--ds-page-pad) calc(var(--ds-page-pad) + var(--ds-safe-right))
    calc(var(--ds-page-pad) + var(--ds-safe-bottom)) calc(var(--ds-page-pad) + var(--ds-safe-left));
  background: var(--ds-bg);
}

.app-content__inner {
  width: 100%;
  max-width: 1600px;
  margin-inline: auto;
  min-height: 100%;
}

.app-shell--bare .app-content.ant-layout-content {
  padding: 0;
}

.app-shell--with-bottomnav .app-content.ant-layout-content {
  padding-bottom: calc(var(--ds-bottomnav-h) + var(--ds-safe-bottom) + var(--ds-space-6));
}

/* ── Desktop sider (navy chrome; menu colors come from chromeMenuTheme in theme.js) ── */
.app-sider.ant-layout-sider {
  z-index: 110;
  background: var(--ds-chrome-gradient);
}

.app-sider .ant-layout-sider-children {
  display: flex;
  flex-direction: column;
  min-height: 0;
}

.app-sider__brand {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  height: var(--ds-topbar-h);
  padding-inline: 22px;
  border-bottom: 1px solid var(--ds-chrome-border);
}

.app-sider__brand img {
  height: 30px;
  width: auto;
  max-width: 100%;
}

.app-sider__brand img.is-mark {
  height: 28px;
}

.ant-layout-sider-collapsed .app-sider__brand {
  justify-content: center;
  padding-inline: 0;
}

.app-sider__nav {
  flex: 1 1 auto;
  min-height: 0;
  overflow-x: hidden;
  overflow-y: auto;
  padding-block: var(--ds-space-2) var(--ds-space-4);
  scrollbar-width: thin;
  scrollbar-color: rgba(255, 255, 255, 0.22) transparent;
}

.app-sider .ant-layout-sider-trigger {
  background: var(--ds-chrome-bg-deep);
  border-top: 1px solid var(--ds-chrome-border);
  color: var(--ds-chrome-text-muted);
}

.app-sider .ant-layout-sider-trigger:hover {
  color: var(--ds-chrome-text-strong);
  background: #0e3144;
}

/* ── Menus (shared by sider and drawer) ── */
.sidersidenav.ant-menu {
  background: transparent;
  border-inline-end: none !important;
  font-weight: 500;
}

.sidersidenav.ant-menu .ant-menu-item,
.sidersidenav.ant-menu .ant-menu-submenu-title {
  width: auto;
}

.sidersidenav.ant-menu .ant-menu-item .anticon,
.sidersidenav.ant-menu .ant-menu-item svg,
.sidersidenav.ant-menu .ant-menu-submenu-title svg {
  color: var(--ds-chrome-text-muted);
  transition: color 0.2s;
}

.sidersidenav.ant-menu .ant-menu-item:hover svg,
.sidersidenav.ant-menu .ant-menu-submenu-title:hover svg {
  color: var(--ds-chrome-text-strong);
}

/* Selected item: sky accent bar on the leading edge, like the logo's cyan strokes */
.sidersidenav.ant-menu .ant-menu-item-selected {
  position: relative;
}

.sidersidenav.ant-menu .ant-menu-item-selected::after {
  content: "";
  position: absolute;
  inset-block: 9px;
  inset-inline: 0 auto;
  width: 3px;
  border: 0;
  border-radius: 0 3px 3px 0;
  background: var(--ds-chrome-accent);
  transform: none;
  opacity: 1;
}

[dir="rtl"] .sidersidenav.ant-menu .ant-menu-item-selected::after {
  border-radius: 3px 0 0 3px;
}

.sidersidenav.ant-menu .ant-menu-item-selected,
.sidersidenav.ant-menu .ant-menu-item-selected a {
  font-weight: 600;
}

.sidersidenav.ant-menu .ant-menu-item-selected svg,
.sidersidenav.ant-menu .ant-menu-item-selected .anticon,
.sidersidenav.ant-menu .ant-menu-submenu-selected > .ant-menu-submenu-title svg {
  color: var(--ds-chrome-accent) !important;
}

.sidersidenav.ant-menu .ant-menu-submenu-selected > .ant-menu-submenu-title {
  color: var(--ds-chrome-text-strong);
  font-weight: 600;
}

/* Submenu children: indented under a guide line */
.sidersidenav.ant-menu-inline .ant-menu-sub.ant-menu-inline {
  position: relative;
  background: transparent;
}

.sidersidenav.ant-menu-inline .ant-menu-sub.ant-menu-inline::before {
  content: "";
  position: absolute;
  inset-block: 6px;
  inset-inline-start: 32px;
  width: 1px;
  background: var(--ds-chrome-border);
}

.sidersidenav.ant-menu-inline .ant-menu-sub .ant-menu-item {
  font-size: 0.875rem;
}

.sidersidenav .ant-menu-title-content a {
  color: inherit;
}

/* Collapsed sider flyouts */
.ant-menu-submenu-popup > .ant-menu {
  min-width: 200px;
  max-width: 280px;
  border-radius: 14px;
  box-shadow: var(--ds-shadow-lg);
  padding: 4px;
}

/* The flyout has no ::after room to spare; the selected fill is enough there */
.ant-menu-submenu-popup .ant-menu-item-selected::after {
  display: none;
}

/* ── Mobile nav drawer ── */
/* Beats the phone-wide "drawers are full width" rule in responsive.css */
.ant-drawer.app-nav-drawer > .ant-drawer-content-wrapper {
  width: min(320px, 86vw) !important;
}

.app-nav-drawer .ant-drawer-content {
  background: var(--ds-chrome-gradient);
  color: var(--ds-chrome-text);
}

.app-nav-drawer__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: calc(var(--ds-space-3) + var(--ds-safe-top)) var(--ds-space-2) var(--ds-space-2)
    var(--ds-space-5);
}

[dir="rtl"] .app-nav-drawer__head {
  padding-inline: var(--ds-space-5) var(--ds-space-2);
}

.app-nav-drawer__head img {
  height: 28px;
  width: auto;
}

.app-nav-drawer__user {
  display: flex;
  align-items: center;
  gap: var(--ds-space-3);
  margin: var(--ds-space-1) var(--ds-space-3) var(--ds-space-3);
  padding: var(--ds-space-3);
  border-radius: var(--ds-radius-lg);
  background: rgba(255, 255, 255, 0.07);
  border: 1px solid var(--ds-chrome-border);
  color: var(--ds-chrome-text) !important;
  text-decoration: none;
}

.app-nav-drawer__name {
  font-weight: 700;
  color: var(--ds-chrome-text-strong);
  line-height: 1.3;
}

.app-nav-drawer__role {
  font-size: 0.8rem;
  color: var(--ds-chrome-text-muted);
}

.app-nav-drawer__menu {
  padding-bottom: calc(var(--ds-space-6) + var(--ds-safe-bottom));
}

.app-nav-drawer .sidersidenav.ant-menu .ant-menu-item,
.app-nav-drawer .sidersidenav.ant-menu .ant-menu-submenu-title {
  font-size: 0.95rem;
}

/* ── Bottom navigation (phones/tablets, service providers) ── */
.app-bottomnav {
  position: fixed;
  inset-inline: 0;
  bottom: 0;
  z-index: 900;
  display: flex;
  height: calc(var(--ds-bottomnav-h) + var(--ds-safe-bottom));
  padding: 0 calc(var(--ds-space-1) + var(--ds-safe-right)) var(--ds-safe-bottom)
    calc(var(--ds-space-1) + var(--ds-safe-left));
  background: rgba(255, 255, 255, 0.94);
  backdrop-filter: saturate(180%) blur(16px);
  -webkit-backdrop-filter: saturate(180%) blur(16px);
  border-top: 1px solid var(--ds-border-soft);
  box-shadow: 0 -6px 20px rgba(19, 33, 44, 0.05);
}

.app-bottomnav__item {
  flex: 1 1 0;
  min-width: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  padding: 6px 2px;
  border: 0;
  background: none;
  color: var(--ds-text-2);
  font: inherit;
  font-size: 0.7rem;
  font-weight: 500;
  text-decoration: none;
  cursor: pointer;
}

/* Icon sits in a pill that fills in when active (Material-style indicator) */
.app-bottomnav__icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 56px;
  height: 30px;
  border-radius: var(--ds-radius-pill);
  transition:
    background-color 0.2s var(--ds-ease),
    color 0.2s var(--ds-ease);
}

.app-bottomnav__item svg {
  font-size: 21px;
  color: inherit !important;
  cursor: inherit !important;
}

.app-bottomnav__item > span:last-child {
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.app-bottomnav__item.is-active {
  color: var(--ds-heading);
  font-weight: 700;
}

.app-bottomnav__item.is-active .app-bottomnav__icon {
  background: var(--ds-brand-100);
  color: var(--ds-brand-dark);
}

.app-bottomnav__item:hover,
.app-bottomnav__item:focus-visible {
  color: var(--ds-heading);
}

/* Things that float at the bottom should clear the bar */
.app-shell--with-bottomnav ~ .ant-float-btn,
.app-shell--with-bottomnav .ant-float-btn {
  bottom: calc(var(--ds-bottomnav-h) + var(--ds-safe-bottom) + 16px) !important;
}

/* ── Desktop ── */
@media (min-width: 992px) {
  .app-topbar.ant-layout-header {
    padding-inline: var(--ds-page-pad);
    gap: var(--ds-space-4);
  }

  .app-topbar__title {
    font-size: var(--ds-title-size);
  }
}
`, "",{"version":3,"sources":["webpack://./src/commons/PanelsHeader/PanelsHeader.css"],"names":[],"mappings":"AAAA;;;;;;iEAMiE;;AAEjE;EACE,aAAa;EACb,cAAc;EACd,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,qDAAqD;EACrD,mBAAmB;EACnB;iDAC+C;EAC/C,+BAA+B;EAC/B,8EAA8E;EAC9E,4BAA4B;AAC9B;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,mCAAmC;EACnC,mCAAmC;EACnC,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;;;EAIE,kCAAkC;AACpC;;AAEA;EACE,mCAAmC;EACnC,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,8CAA8C;EAC9C,eAAe;EACf,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,cAAc;EACd,wEAAwE;EACxE,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,0BAA0B;EAC1B,uBAAuB;EACvB,4BAA4B;EAC5B,SAAS;EACT,oCAAoC;EACpC,uBAAuB;EACvB,4BAA4B;EAC5B,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,mCAAmC;EACnC,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,kCAAkC;EAClC,oCAAoC;AACtC;;AAEA;EACE,0BAA0B;EAC1B,uBAAuB;EACvB,uBAAuB;EACvB,kCAAkC;EAClC,gBAAgB;EAChB,uCAAuC;AACzC;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,6CAA6C;EAC7C,8CAA8C;AAChD;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,sBAAsB;EACtB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,iBAAiB;EACjB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;EACE,YAAY;EACZ,kFAAkF;EAClF,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,8BAA8B;EAC9B;mGACiG;EACjG,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,uFAAuF;AACzF;;AAEA,yFAAyF;AACzF;EACE,YAAY;EACZ,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,0BAA0B;EAC1B,oBAAoB;EACpB,gDAAgD;AAClD;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,kDAAkD;EAClD,qBAAqB;EACrB,sDAAsD;AACxD;;AAEA;EACE,oCAAoC;EACpC,6CAA6C;EAC7C,kCAAkC;AACpC;;AAEA;EACE,mCAAmC;EACnC,mBAAmB;AACrB;;AAEA,6CAA6C;AAC7C;EACE,uBAAuB;EACvB,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;;EAEE,WAAW;AACb;;AAEA;;;EAGE,kCAAkC;EAClC,sBAAsB;AACxB;;AAEA;;EAEE,mCAAmC;AACrC;;AAEA,oFAAoF;AACpF;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,UAAU;EACV,SAAS;EACT,0BAA0B;EAC1B,mCAAmC;EACnC,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;;;EAGE,yCAAyC;AAC3C;;AAEA;EACE,mCAAmC;EACnC,gBAAgB;AAClB;;AAEA,kDAAkD;AAClD;EACE,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,UAAU;EACV,mCAAmC;AACrC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA,4BAA4B;AAC5B;EACE,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,+BAA+B;EAC/B,YAAY;AACd;;AAEA,+EAA+E;AAC/E;EACE,aAAa;AACf;;AAEA,4BAA4B;AAC5B,yEAAyE;AACzE;EACE,kCAAkC;AACpC;;AAEA;EACE,qCAAqC;EACrC,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B;qBACmB;AACrB;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,6DAA6D;EAC7D,0BAA0B;EAC1B,kCAAkC;EAClC,qCAAqC;EACrC,yCAAyC;EACzC,uCAAuC;EACvC,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,mCAAmC;EACnC,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,kCAAkC;AACpC;;AAEA;EACE,+DAA+D;AACjE;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA,gEAAgE;AAChE;EACE,eAAe;EACf,eAAe;EACf,SAAS;EACT,YAAY;EACZ,aAAa;EACb,2DAA2D;EAC3D;iDAC+C;EAC/C,qCAAqC;EACrC,0CAA0C;EAC1C,kDAAkD;EAClD,2CAA2C;EAC3C,8CAA8C;AAChD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,SAAS;EACT,gBAAgB;EAChB,uBAAuB;EACvB,aAAa;EACb,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;AACjB;;AAEA,6EAA6E;AAC7E;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC;;6BAE2B;AAC7B;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,2BAA2B;AAC7B;;AAEA;;EAEE,wBAAwB;AAC1B;;AAEA,yDAAyD;AACzD;;EAEE,6EAA6E;AAC/E;;AAEA,kBAAkB;AAClB;EACE;IACE,kCAAkC;IAClC,sBAAsB;EACxB;;EAEA;IACE,+BAA+B;EACjC;AACF","sourcesContent":["/* ============================================================\n   App shell — mobile first.\n   Phone/tablet (<992px): navy top bar + drawer nav (+ bottom bar).\n   Desktop: navy full-height sider + navy top bar with the page\n   title. Content is the scroll container in both (TaskBoard relies\n   on .ant-layout-content).\n   ============================================================ */\n\n.app-shell {\n  height: 100vh;\n  height: 100dvh;\n  overflow: hidden;\n  background: var(--ds-bg);\n}\n\n.app-shell__main {\n  flex: 1 1 auto;\n  min-width: 0;\n  min-height: 0;\n  overflow: hidden;\n  background: var(--ds-bg);\n}\n\n/* ── Top bar ── */\n.app-topbar.ant-layout-header {\n  position: relative;\n  z-index: 100;\n  display: flex;\n  align-items: center;\n  gap: var(--ds-space-2);\n  height: calc(var(--ds-topbar-h) + var(--ds-safe-top));\n  line-height: normal;\n  padding: var(--ds-safe-top) calc(var(--ds-space-2) + var(--ds-safe-right)) 0\n    calc(var(--ds-space-2) + var(--ds-safe-left));\n  background: var(--ds-chrome-bg);\n  box-shadow: 0 1px 0 var(--ds-chrome-border), 0 4px 16px rgba(18, 58, 79, 0.18);\n  color: var(--ds-chrome-text);\n}\n\n.app-topbar__heading {\n  flex: 1 1 auto;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  gap: 2px;\n}\n\n.app-topbar__title {\n  margin: 0;\n  color: var(--ds-chrome-text-strong);\n  font-family: var(--ds-font-display);\n  font-size: 1.1rem;\n  font-weight: 700;\n  letter-spacing: -0.01em;\n  line-height: 1.2;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.app-topbar .ant-breadcrumb {\n  font-size: 0.78rem;\n  line-height: 1.2;\n}\n\n.app-topbar .ant-breadcrumb,\n.app-topbar .ant-breadcrumb a,\n.app-topbar .ant-breadcrumb li:last-child,\n.app-topbar .ant-breadcrumb .ant-breadcrumb-separator {\n  color: var(--ds-chrome-text-muted);\n}\n\n.app-topbar .ant-breadcrumb a:hover {\n  color: var(--ds-chrome-text-strong);\n  background: transparent;\n}\n\n.app-topbar__actions {\n  display: flex;\n  align-items: center;\n  gap: var(--ds-space-1);\n  margin-inline-start: auto;\n}\n\n.app-topbar__icon-btn.ant-btn {\n  width: var(--ds-touch);\n  height: var(--ds-touch);\n  color: var(--ds-chrome-text-strong) !important;\n  font-size: 20px;\n  flex-shrink: 0;\n  border-radius: var(--ds-radius-md);\n}\n\n.app-topbar__icon-btn.ant-btn:hover {\n  background: var(--ds-chrome-hover) !important;\n}\n\n.app-avatar.ant-avatar {\n  flex-shrink: 0;\n  background: linear-gradient(135deg, var(--ds-logo-sky), var(--ds-brand));\n  color: #fff;\n  font-weight: 700;\n  font-size: 0.8rem;\n  letter-spacing: 0.02em;\n}\n\n.app-topbar__user {\n  display: flex;\n  align-items: center;\n  gap: var(--ds-space-2);\n  min-width: var(--ds-touch);\n  height: var(--ds-touch);\n  padding: 0 var(--ds-space-1);\n  border: 0;\n  border-radius: var(--ds-radius-pill);\n  background: transparent;\n  color: var(--ds-chrome-text);\n  cursor: pointer;\n  text-align: start;\n}\n\n.app-topbar__user:hover {\n  background: var(--ds-chrome-hover);\n}\n\n.app-topbar__user .app-avatar.ant-avatar {\n  box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.85);\n}\n\n.app-topbar__user-text {\n  display: flex;\n  flex-direction: column;\n  line-height: 1.2;\n  max-width: 180px;\n}\n\n.app-topbar__user-name {\n  font-weight: 600;\n  font-size: 0.875rem;\n  color: var(--ds-chrome-text-strong);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.app-topbar__user-role {\n  font-size: 0.75rem;\n  color: var(--ds-chrome-text-muted);\n  white-space: nowrap;\n}\n\n.app-topbar__user-caret {\n  font-size: 10px;\n  color: var(--ds-chrome-text-muted);\n  margin-inline-end: var(--ds-space-1);\n}\n\n.app-topbar .language-selector {\n  min-width: var(--ds-touch);\n  height: var(--ds-touch);\n  justify-content: center;\n  border-radius: var(--ds-radius-md);\n  font-weight: 600;\n  color: var(--ds-chrome-text) !important;\n}\n\n.app-topbar .language-selector .ant-typography,\n.app-topbar .language-selector svg {\n  color: inherit !important;\n}\n\n.app-topbar .language-selector:hover {\n  background: var(--ds-chrome-hover) !important;\n  color: var(--ds-chrome-text-strong) !important;\n}\n\n.language-country-flag {\n  width: 20px;\n  border-radius: 3px;\n}\n\n/* Profile menu */\n.app-usermenu__head {\n  display: flex;\n  flex-direction: column;\n  padding: var(--ds-space-1) 0;\n  min-width: 200px;\n}\n\n.app-usermenu__name {\n  font-weight: 700;\n  color: var(--ds-heading);\n}\n\n.app-usermenu__role {\n  font-size: 0.8rem;\n  color: var(--ds-text-2);\n  font-weight: 400;\n}\n\n/* ── Content ── */\n.app-content.ant-layout-content {\n  min-width: 0;\n  /* normalUsers/assets/css/custom.css centers a template \".app-content\" on phones */\n  text-align: start;\n  overflow-x: hidden;\n  overflow-y: auto;\n  overscroll-behavior-y: contain;\n  padding: var(--ds-page-pad) calc(var(--ds-page-pad) + var(--ds-safe-right))\n    calc(var(--ds-page-pad) + var(--ds-safe-bottom)) calc(var(--ds-page-pad) + var(--ds-safe-left));\n  background: var(--ds-bg);\n}\n\n.app-content__inner {\n  width: 100%;\n  max-width: 1600px;\n  margin-inline: auto;\n  min-height: 100%;\n}\n\n.app-shell--bare .app-content.ant-layout-content {\n  padding: 0;\n}\n\n.app-shell--with-bottomnav .app-content.ant-layout-content {\n  padding-bottom: calc(var(--ds-bottomnav-h) + var(--ds-safe-bottom) + var(--ds-space-6));\n}\n\n/* ── Desktop sider (navy chrome; menu colors come from chromeMenuTheme in theme.js) ── */\n.app-sider.ant-layout-sider {\n  z-index: 110;\n  background: var(--ds-chrome-gradient);\n}\n\n.app-sider .ant-layout-sider-children {\n  display: flex;\n  flex-direction: column;\n  min-height: 0;\n}\n\n.app-sider__brand {\n  flex: 0 0 auto;\n  display: flex;\n  align-items: center;\n  height: var(--ds-topbar-h);\n  padding-inline: 22px;\n  border-bottom: 1px solid var(--ds-chrome-border);\n}\n\n.app-sider__brand img {\n  height: 30px;\n  width: auto;\n  max-width: 100%;\n}\n\n.app-sider__brand img.is-mark {\n  height: 28px;\n}\n\n.ant-layout-sider-collapsed .app-sider__brand {\n  justify-content: center;\n  padding-inline: 0;\n}\n\n.app-sider__nav {\n  flex: 1 1 auto;\n  min-height: 0;\n  overflow-x: hidden;\n  overflow-y: auto;\n  padding-block: var(--ds-space-2) var(--ds-space-4);\n  scrollbar-width: thin;\n  scrollbar-color: rgba(255, 255, 255, 0.22) transparent;\n}\n\n.app-sider .ant-layout-sider-trigger {\n  background: var(--ds-chrome-bg-deep);\n  border-top: 1px solid var(--ds-chrome-border);\n  color: var(--ds-chrome-text-muted);\n}\n\n.app-sider .ant-layout-sider-trigger:hover {\n  color: var(--ds-chrome-text-strong);\n  background: #0e3144;\n}\n\n/* ── Menus (shared by sider and drawer) ── */\n.sidersidenav.ant-menu {\n  background: transparent;\n  border-inline-end: none !important;\n  font-weight: 500;\n}\n\n.sidersidenav.ant-menu .ant-menu-item,\n.sidersidenav.ant-menu .ant-menu-submenu-title {\n  width: auto;\n}\n\n.sidersidenav.ant-menu .ant-menu-item .anticon,\n.sidersidenav.ant-menu .ant-menu-item svg,\n.sidersidenav.ant-menu .ant-menu-submenu-title svg {\n  color: var(--ds-chrome-text-muted);\n  transition: color 0.2s;\n}\n\n.sidersidenav.ant-menu .ant-menu-item:hover svg,\n.sidersidenav.ant-menu .ant-menu-submenu-title:hover svg {\n  color: var(--ds-chrome-text-strong);\n}\n\n/* Selected item: sky accent bar on the leading edge, like the logo's cyan strokes */\n.sidersidenav.ant-menu .ant-menu-item-selected {\n  position: relative;\n}\n\n.sidersidenav.ant-menu .ant-menu-item-selected::after {\n  content: \"\";\n  position: absolute;\n  inset-block: 9px;\n  inset-inline: 0 auto;\n  width: 3px;\n  border: 0;\n  border-radius: 0 3px 3px 0;\n  background: var(--ds-chrome-accent);\n  transform: none;\n  opacity: 1;\n}\n\n[dir=\"rtl\"] .sidersidenav.ant-menu .ant-menu-item-selected::after {\n  border-radius: 3px 0 0 3px;\n}\n\n.sidersidenav.ant-menu .ant-menu-item-selected,\n.sidersidenav.ant-menu .ant-menu-item-selected a {\n  font-weight: 600;\n}\n\n.sidersidenav.ant-menu .ant-menu-item-selected svg,\n.sidersidenav.ant-menu .ant-menu-item-selected .anticon,\n.sidersidenav.ant-menu .ant-menu-submenu-selected > .ant-menu-submenu-title svg {\n  color: var(--ds-chrome-accent) !important;\n}\n\n.sidersidenav.ant-menu .ant-menu-submenu-selected > .ant-menu-submenu-title {\n  color: var(--ds-chrome-text-strong);\n  font-weight: 600;\n}\n\n/* Submenu children: indented under a guide line */\n.sidersidenav.ant-menu-inline .ant-menu-sub.ant-menu-inline {\n  position: relative;\n  background: transparent;\n}\n\n.sidersidenav.ant-menu-inline .ant-menu-sub.ant-menu-inline::before {\n  content: \"\";\n  position: absolute;\n  inset-block: 6px;\n  inset-inline-start: 32px;\n  width: 1px;\n  background: var(--ds-chrome-border);\n}\n\n.sidersidenav.ant-menu-inline .ant-menu-sub .ant-menu-item {\n  font-size: 0.875rem;\n}\n\n.sidersidenav .ant-menu-title-content a {\n  color: inherit;\n}\n\n/* Collapsed sider flyouts */\n.ant-menu-submenu-popup > .ant-menu {\n  min-width: 200px;\n  max-width: 280px;\n  border-radius: 14px;\n  box-shadow: var(--ds-shadow-lg);\n  padding: 4px;\n}\n\n/* The flyout has no ::after room to spare; the selected fill is enough there */\n.ant-menu-submenu-popup .ant-menu-item-selected::after {\n  display: none;\n}\n\n/* ── Mobile nav drawer ── */\n/* Beats the phone-wide \"drawers are full width\" rule in responsive.css */\n.ant-drawer.app-nav-drawer > .ant-drawer-content-wrapper {\n  width: min(320px, 86vw) !important;\n}\n\n.app-nav-drawer .ant-drawer-content {\n  background: var(--ds-chrome-gradient);\n  color: var(--ds-chrome-text);\n}\n\n.app-nav-drawer__head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: calc(var(--ds-space-3) + var(--ds-safe-top)) var(--ds-space-2) var(--ds-space-2)\n    var(--ds-space-5);\n}\n\n[dir=\"rtl\"] .app-nav-drawer__head {\n  padding-inline: var(--ds-space-5) var(--ds-space-2);\n}\n\n.app-nav-drawer__head img {\n  height: 28px;\n  width: auto;\n}\n\n.app-nav-drawer__user {\n  display: flex;\n  align-items: center;\n  gap: var(--ds-space-3);\n  margin: var(--ds-space-1) var(--ds-space-3) var(--ds-space-3);\n  padding: var(--ds-space-3);\n  border-radius: var(--ds-radius-lg);\n  background: rgba(255, 255, 255, 0.07);\n  border: 1px solid var(--ds-chrome-border);\n  color: var(--ds-chrome-text) !important;\n  text-decoration: none;\n}\n\n.app-nav-drawer__name {\n  font-weight: 700;\n  color: var(--ds-chrome-text-strong);\n  line-height: 1.3;\n}\n\n.app-nav-drawer__role {\n  font-size: 0.8rem;\n  color: var(--ds-chrome-text-muted);\n}\n\n.app-nav-drawer__menu {\n  padding-bottom: calc(var(--ds-space-6) + var(--ds-safe-bottom));\n}\n\n.app-nav-drawer .sidersidenav.ant-menu .ant-menu-item,\n.app-nav-drawer .sidersidenav.ant-menu .ant-menu-submenu-title {\n  font-size: 0.95rem;\n}\n\n/* ── Bottom navigation (phones/tablets, service providers) ── */\n.app-bottomnav {\n  position: fixed;\n  inset-inline: 0;\n  bottom: 0;\n  z-index: 900;\n  display: flex;\n  height: calc(var(--ds-bottomnav-h) + var(--ds-safe-bottom));\n  padding: 0 calc(var(--ds-space-1) + var(--ds-safe-right)) var(--ds-safe-bottom)\n    calc(var(--ds-space-1) + var(--ds-safe-left));\n  background: rgba(255, 255, 255, 0.94);\n  backdrop-filter: saturate(180%) blur(16px);\n  -webkit-backdrop-filter: saturate(180%) blur(16px);\n  border-top: 1px solid var(--ds-border-soft);\n  box-shadow: 0 -6px 20px rgba(19, 33, 44, 0.05);\n}\n\n.app-bottomnav__item {\n  flex: 1 1 0;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 4px;\n  padding: 6px 2px;\n  border: 0;\n  background: none;\n  color: var(--ds-text-2);\n  font: inherit;\n  font-size: 0.7rem;\n  font-weight: 500;\n  text-decoration: none;\n  cursor: pointer;\n}\n\n/* Icon sits in a pill that fills in when active (Material-style indicator) */\n.app-bottomnav__icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 56px;\n  height: 30px;\n  border-radius: var(--ds-radius-pill);\n  transition:\n    background-color 0.2s var(--ds-ease),\n    color 0.2s var(--ds-ease);\n}\n\n.app-bottomnav__item svg {\n  font-size: 21px;\n  color: inherit !important;\n  cursor: inherit !important;\n}\n\n.app-bottomnav__item > span:last-child {\n  max-width: 100%;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.app-bottomnav__item.is-active {\n  color: var(--ds-heading);\n  font-weight: 700;\n}\n\n.app-bottomnav__item.is-active .app-bottomnav__icon {\n  background: var(--ds-brand-100);\n  color: var(--ds-brand-dark);\n}\n\n.app-bottomnav__item:hover,\n.app-bottomnav__item:focus-visible {\n  color: var(--ds-heading);\n}\n\n/* Things that float at the bottom should clear the bar */\n.app-shell--with-bottomnav ~ .ant-float-btn,\n.app-shell--with-bottomnav .ant-float-btn {\n  bottom: calc(var(--ds-bottomnav-h) + var(--ds-safe-bottom) + 16px) !important;\n}\n\n/* ── Desktop ── */\n@media (min-width: 992px) {\n  .app-topbar.ant-layout-header {\n    padding-inline: var(--ds-page-pad);\n    gap: var(--ds-space-4);\n  }\n\n  .app-topbar__title {\n    font-size: var(--ds-title-size);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
